export default __webpack_public_path__ + "static/media/15.0589c8f4.jpg";